"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const StaticWidgetRenderer_1 = tslib_1.__importDefault(require("./StaticWidgetRenderer"));
const RepeatableRenderer = (ctx) => {
    return {
        renderV1(content, fetch) {
            return content.value.map((item) => {
                return (0, StaticWidgetRenderer_1.default)(ctx).renderV1(item, fetch);
            });
        },
        renderV2(def, content, fetch) {
            return content.value.map((item) => {
                return (0, StaticWidgetRenderer_1.default)(ctx).renderV2(
                // Override the repeat value to false to prevent propagating the repeat configuration.
                // Items inside a repeatable array should not be repeatable.
                {
                    ...def,
                    config: {
                        ...def.config,
                        repeat: false,
                    },
                }, item, fetch);
            });
        },
        renderDefault() {
            return [];
        },
        renderMocks(def, content) {
            return content.value.map((item) => {
                return (0, StaticWidgetRenderer_1.default)(ctx).renderMocks(
                // Override the repeat value to false to prevent propagating the repeat configuration.
                // Items inside a repeatable array should not be repeatable.
                {
                    ...def,
                    config: {
                        ...def.config,
                        repeat: false,
                    },
                }, item);
            });
        },
    };
};
exports.default = RepeatableRenderer;
